import { createContext, ReactNode } from 'react';

export type ComponentContextProps = {
  variant:
    | 'default'
    | 'plain'
    | 'primary'
    | 'secondary'
    | 'tertiary'
    | 'error'
    | 'danger'
    | 'warning'
    | 'success'
    | 'trigger'
    | 'export'
    | 'field-type'
    | 'formatter'
    | 'validator';
};

export const ComponentContext = createContext<ComponentContextProps>({ variant: 'default' });

export function renderWithContext(children: ReactNode, context: ComponentContextProps): ReactNode;
export function renderWithContext<T>(
  children: ReactNode | ((values: T) => ReactNode),
  context: ComponentContextProps,
  renderProps?: T
): ((values: T) => ReactNode) | ReactNode;
export function renderWithContext<T>(
  children: ReactNode | ((values: T) => ReactNode),
  context: ComponentContextProps,
  renderProps?: T
): ((values: T) => ReactNode) | ReactNode {
  if (typeof children === 'function') {
    if (renderProps) {
      return <ComponentContext value={context}>{children(renderProps)}</ComponentContext>;
    } else {
      return (values: T) => <ComponentContext value={context}>{children(values)}</ComponentContext>;
    }
  } else {
    return <ComponentContext value={context}>{children}</ComponentContext>;
  }
}
